module.exports = __webpack_public_path__ + "img/login-background.2e9d6011.jpg";